import { render } from "./ActionCallout.vue?vue&type=template&id=0565ad29"
import script from "./ActionCallout.vue?vue&type=script&lang=js"
export * from "./ActionCallout.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ActionCallout.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_f973ce7a%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fhome%2FActionCallout.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__